import styled from "styled-components";

export const DropDownCPMobileContainer = styled.div`
  width: 100%;

  display: flex;
  gap: 1rem;
  padding: 1rem;
  align-items: center;

  p {
    font-size: 16px;
    font-weight: 600;
    color: ${({ theme }) => theme.controlPanel?.textControlPanel};
    margin-bottom: 0;
  }
  .arrow-down-cp {
    color: ${({ theme }) => theme.controlPanel?.textControlPanel};
  }
`;

export const ContainerShowMenu = styled.div`
  display: flex;
  left: 0;
  top: 0;
  margin-top: 5rem;

  z-index: 99999;
  position: absolute;

  height: 100rem;
  width: 16rem;

  background: ${({ theme }) =>
    theme.controlPanel?.secondaryBackgroundControlPanel};
`;
